import { render } from "./PriceSheetsPage.vue?vue&type=template&id=c0fb8082&scoped=true"
import script from "./PriceSheetsPage.vue?vue&type=script&lang=js"
export * from "./PriceSheetsPage.vue?vue&type=script&lang=js"

import "./PriceSheetsPage.vue?vue&type=style&index=0&id=c0fb8082&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0fb8082"]])

export default __exports__